import { Controller } from "@hotwired/stimulus"

// Celebrates a finished article: a burst of confetti from the element on
// connect, and confetti with sparkles from the celebrate action. party-js is
// loaded on demand so it stays out of the public bundle.
export default class extends Controller {
  connect() {
    return this.#burst({ min: 400, max: 400 })
  }

  celebrate() {
    return this.#burst({ min: 50, max: 100, sparkles: true })
  }

  async #burst({ min, max, sparkles = false }) {
    const { default: party } = await import("party-js")
    const options = {
      count: party.variation.range(min, max),
      size: party.variation.range(0.8, 1.2),
    }

    party.confetti(this.element, options)
    if (sparkles) party.sparkles(this.element, options)
  }
}
